// Sound (Loudness) units with conversion factors to decibel (dB)
export const soundUnits = [
  { id: 'decibel', name: 'Decibel', symbol: 'dB', plural: 'Decibels', factor: 1 },
  { id: 'bel', name: 'Bel', symbol: 'B', plural: 'Bels', factor: 10 },
  { id: 'neper', name: 'Neper', symbol: 'Np', plural: 'Nepers', factor: 8.685889638 },
];

export const popularSoundConversions = [
  { from: 'decibel', to: 'bel' },
  { from: 'bel', to: 'decibel' },
  { from: 'decibel', to: 'neper' },
  { from: 'neper', to: 'decibel' },
];

export const getUnitById = (id) => soundUnits.find(unit => unit.id === id);

export const convertSound = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert sound level units and learn the conversion formula.`;
};
